import ListaDeAgendadosPagina from "./ListaDeAgendadosPagina";

export default ListaDeAgendadosPagina;